import { createSlice } from "@reduxjs/toolkit";
import moment from 'moment';

// El pago se registra por defecto en efectivo. La entidad se elige entre
// las personas juridicas de tipo Banco.
export const MEDIO_PAGO_EFECTIVO = 201;

// Se exporta la fabrica para que cada pago nuevo nazca con esos valores.
export const nuevoPago = () => ({
    id: 0,
    numero: 0,
    idMedioPago: MEDIO_PAGO_EFECTIVO,
    medioPago: "Efectivo",
    idEntidadPago: 0,
    entidadPago: "",
    numeroCuenta: "",
    numeroOperacion: "",
    numeroVoucher: "",
    fechaPago: new Date(),
    idMoneda: 0,
    moneda: "",
    tipoCambio: 0.0,
    monto: 0.0,
    observaciones: "",
    idEstado: 2,
    estado: "",
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
});

const data = {
    entity: nuevoPago(),
    listMedioPago: [{id: 0, descripcion: ""}],
    listEntidadPago: [{id: 0, descripcion: ""}],
    listMoneda: [{id: 0, descripcion: ""}],
    listEstado: [{id: 0, descripcion: ""}],
    validationActive: {
        idMedioPago: false,
        idEntidadPago: false,
        numeroOperacion: false,
        fechaPago: false,
    },
    validationMessage: [],
  }

  export const receiptPaymentSlice = createSlice({
    name: "receiptPayment",
    initialState: {},
    reducers: {
      init: (state, action) => {
        const { sliceKey } = action.payload;
        if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
      },
      setEntity: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].entity = data;
      },
      setData: (state, action) => {
        var { sliceKey, name, value } = action.payload;

        if (name.startsWith("id")) value = parseInt(value)

        state[sliceKey].entity[name] = value
        state[sliceKey].validationActive[name] = true
      },
      setListMedioPago: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listMedioPago = data;
      },
      setListEntidadPago: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listEntidadPago = data;
      },
      setListMoneda: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listMoneda = data;
      },
      setListEstado: (state, action) => {
        const {sliceKey, data} = action.payload;
        state[sliceKey].listEstado = data;
      },
      setValidationMessage: (state, action) => {
        const {sliceKey, message} = action.payload;
        state[sliceKey].validationMessage = message;
      },
      activeValidations: (state, action) => {
        const {sliceKey} = action.payload;
        Object.keys(state[sliceKey].validationActive).forEach(function (key) {
            state[sliceKey].validationActive[key] = true;
        })
      },
    },
  });

  export const { init, setEntity, setData, setValidationMessage, activeValidations
    , setListMedioPago, setListEntidadPago, setListMoneda, setListEstado
    } = receiptPaymentSlice.actions;

  // Se mantiene por compatibilidad con las importaciones antigas.
  export const defaultReceiptPayment = nuevoPago();
  export default receiptPaymentSlice.reducer;